import React from "react";
import { Box, Card, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
// Generic metric card that can render either an icon or a circular progress on the left
export const MetricCard = ({ title, value, subtitle, left, onClick, leftSlot, variant, titlePlacement = "above", }) => {
    const theme = useTheme();
    const isTablet = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const renderLeft = () => {
        if (leftSlot)
            return leftSlot;
        if (!left)
            return null;
        return (React.createElement(Box, { display: "inline-flex", alignItems: "center", justifyContent: "center", width: 85, height: 85, color: theme.palette.primary.main }, left.icon));
    };
    return (React.createElement(Card, { onClick: onClick, sx: {
            display: "flex",
            alignItems: "center",
            p: 0,
            borderRadius: 3,
            boxShadow: "0 12px 24px rgba(0,0,0,0.04)",
            border: "1px solid",
            borderColor: "divider",
            cursor: onClick ? "pointer" : "default",
        } },
        renderLeft(),
        React.createElement(Stack, null,
            titlePlacement === "above" && (React.createElement(Typography, { variant: "overline", color: "text.primary" }, title)),
            React.createElement(Typography, { variant: variant, fontWeight: 500, color: "text.primary" }, value),
            titlePlacement === "belowValue" ? (React.createElement(Typography, { variant: "body2", color: "text.primary" }, title)) : (subtitle && (React.createElement(Typography, { variant: "body2", color: "text.primary" }, subtitle))))));
};
